<template>
    <div class="bg-white relative z-0">
        <div class="page-container">
            <div class="px-8 md:px-5 py-5 ">
                <h1 class="mb-6">
                    Where do I find my ID number?
                </h1>


                <p class="mb-2">
                    The ID number is on a label inside the front door.
                </p>
                <p class="mb-6">
                    <img src="../assets/sharp-id-example.jpg" alt="How to find Machine ID"/>
                </p>
                <p class="mb-2">
                    For example:
                </p>

                <p class="mb-6">
                    <span class="inline-block p-4">
                        <img src="../assets/sharp-example1.jpg" alt="How to find Machine ID"/>
                    </span>
                    <span class="inline-block p-4">
                        <img src="../assets/sharp-example2.jpg" alt="How to find Machine ID"/>
                    </span>
                    <span class="inline-block p-4">
                        <img src="../assets/sharp-example3.jpg" alt="How to find Machine ID"/>
                    </span>
                </p>


                <p class="mt-8">
                    <router-link :to="{ name: 'autologin' }" class="btn">
                        Go Back
                    </router-link>
                </p>
            </div>
        </div>
    </div>
</template>

